import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import custom from './online-course_container.scss';

export const OnlineCourseContainer = ({ children, pointer, htmlEnabled }) => (
  <div
    className={`${custom['online-course_container']} ${cx({
      [custom['online-course_container-box-shadow']]: htmlEnabled,
      [custom['online-course_container-enabled']]: htmlEnabled,
    })}`}
    style={{
      cursor: pointer ? 'pointer' : 'auto',
    }}
  >
    {children}
  </div>
);

OnlineCourseContainer.propTypes = {
  children: PropTypes.node.isRequired,
  pointer: PropTypes.bool,
  htmlEnabled: PropTypes.bool,
};

OnlineCourseContainer.defaultProps = {
  pointer: true,
  htmlEnabled: false,
};
